// extracted by mini-css-extract-plugin
export default {"button":"AddRoleButton_button__3vxuZ","icon":"AddRoleButton_icon__KVJsA","text":"AddRoleButton_text__PFw4v"};